import { JsonObject } from '@/lib/helpers';
import { PropModel } from '../prop.model';
import { has } from 'lodash';

export type TileType = 'none' | 'surepath' | 'public-service' | 'agent' | 'conversation';

export class TileModel extends PropModel {
  tileType: TileType;
  resourceId: string;
  createdAt: number;
  serviceId?: string;
  recent?: number;
  favorite?: boolean;
  keywords: string[];
  hasAccess: boolean;

  constructor(props: JsonObject = {}) {
    super();
    const data = props as Record<keyof TileModel, unknown>;
    this.tileType = (data.tileType as TileType) || 'none';
    this.resourceId = (data.resourceId as string) || '';
    this.createdAt = (data.createdAt as number) || 0;

    if (data.serviceId) {
      this.serviceId = data.serviceId as string;
    }

    if (data.recent) {
      this.recent = data.recent as number;
    }

    if (has(data, 'favorite')) {
      this.favorite = !!data.favorite;
    }

    this.keywords = [];
    this.hasAccess = has(data, 'hasAccess') ? !!data.hasAccess : true;
  }

  get id(): string {
    return this.tileId;
  }

  get tileId(): string {
    return `${this.tileType}-${this.resourceId}`;
  }

  get typeLabel(): string {
    switch (this.tileType) {
      case 'agent':
        return 'assistant';
      case 'conversation':
        return 'conversation';
      default:
        return 'app';
    }
  }
}

export class TileMetaModel extends PropModel {
  tileType: TileType;
  resourceId: string;
  createdAt: number;
  serviceId?: string;

  constructor(props: JsonObject = {}) {
    super();
    const data = props as Record<keyof TileMetaModel, unknown>;
    this.tileType = (data.tileType as TileType) || 'none';
    this.resourceId = (data.resourceId as string) || '';
    this.createdAt = (data.createdAt as number) || 0;

    if (data.serviceId) {
      this.serviceId = data.serviceId as string;
    }
  }

  get tileId(): string {
    return `${this.tileType}-${this.resourceId}`;
  }
}
